import * as Icons from "heroicons-react";
import { useState } from "react";
import { Button, ButtonGroup } from "react-bootstrap";
import { Link } from "react-router-dom";
import SelectHoldSale from "../../../Common/CustomSelect/SelectHoldSale";
// import { FontAwesomeIcon } from "@react";
import "./PosFooter.css";
import logo from "../../../../logo-s.svg";
const PosFooter = ({
  emptyCart,
  LastBillId,
  handleHoldSale,
  holdSale,
  handleReturn,
  handlePayDue,
  updateCartState,
  salesRerurnButton,
  holdBillButton,
  lastBillButton
}) => {
  const holdCart = JSON.parse(localStorage.getItem("hold_cart"));
  const holdLength = holdCart?.length;
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  // Toggle Popup Visibility
  const togglePopup = () => setIsPopupOpen((prevState) => !prevState);

  return (
    <footer className="fixed-bottom">
      <div className="container-fluid d-block d-md-none">
        <div className="floating-menu">
          {/* Floating Button */}
          <div className="floating-btn" onClick={togglePopup}>
            <img src={logo} alt="" />
          </div>

          {/* Popup Menu */}
          {isPopupOpen && (
            <div className="popup-menu">
              <Button
                variant="dark"
                onClick={handleReturn}
                ref={salesRerurnButton}
                className="popup-btn"
              >
                <Icons.ReplyOutline className="icon" size={18} />
                Return
              </Button>

              {holdLength > 0 && (
                <SelectHoldSale updateCartState={updateCartState} />
              )}

              <Button
                variant="warning"
                onClick={handleHoldSale}
                ref={holdBillButton}
                className="popup-btn"
              >
                <Icons.HandOutline className="icon" size={18} />
                {holdLength > 0 ? `Hold (${holdLength})` : "Hold"}
              </Button>

              <Button
                variant="success"
                onClick={emptyCart}
                className="popup-btn"
              >
                <Icons.Refresh className="icon" size={18} />
                Refresh
              </Button>

              <Button
                variant="dark"
                onClick={handlePayDue}
                ref={salesRerurnButton}
                className="popup-btn"
              >
                <Icons.CurrencyBangladeshi className="icon" size={18} />
                Pay Due Bill
              </Button>

              <Link
                className="btn btn-primary popup-btn"
                to={`/print/${LastBillId ? LastBillId : "last"}`}
                target="_blank"
                ref={lastBillButton}
              >
                <Icons.PrinterOutline className="icon" size={18} />
                Last Bill
              </Link>
            </div>
          )}
        </div>
      </div>

      <div className="container-fluid d-none d-md-block">
        <div className="row">
          <div className="col-md-6">
            <div className="card">
              <ButtonGroup aria-label="Basic">
                {/* <Button variant="info" >
                        Sales 
                        <Icons.ClipboardListOutline className='ms-3'  size={18}/>         
                  </Button> */}
                <Button
                  variant="dark d-block"
                  ref={salesRerurnButton}
                  onClick={handleReturn}
                >
                  Return
                  <Icons.ReplyOutline className="ms-3" size={18} />
                  {/* <Icons.XOutline  className='ms-3' size={18}/> */}
                </Button>
                {/* <Button variant="secondary"> */}
                {holdLength > 0 && (
                  <SelectHoldSale updateCartState={updateCartState} />
                )}
                {/* </Button> */}
                <Button
                  variant="warning"
                  onClick={handleHoldSale}
                  ref={holdBillButton}
                >
                  {holdLength > 0 && `(${holdLength})`} Hold
                  <Icons.HandOutline className="ms-3" size={18} />
                </Button>
                <Button variant="success" onClick={emptyCart}>
                  Refresh
                  <Icons.Refresh className="ms-3" size={18} />
                </Button>
                <Button
                  variant="dark d-block"
                  ref={salesRerurnButton}
                  onClick={handlePayDue}
                >
                  Pay Due Bill
                  <Icons.CurrencyBangladeshi className="ms-3" size={18} />
                  {/* <Icons.XOutline  className='ms-3' size={18}/> */}
                </Button>
                <Link
                  variant="primary"
                  className="btn btn-primary"
                  to={`/print/${LastBillId ? LastBillId : "last"}`}
                  target="_blank"
                  ref={lastBillButton}
                >
                  Last Bill
                  <Icons.PrinterOutline className="ms-3" size={18} />
                </Link>
              </ButtonGroup>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default PosFooter;
